import { appType, clientKey } from '@/config'
import storage from '@/utils/storage'

export default {
  namespaced: true,
  state: {
    clientKey: storage.get('clientKey') || clientKey,
    appType: storage.get('appType') || appType,
    appid: storage.get('appid') || ''
  },
  actions: {
    setClientKey({ state }, clientKey) {
      state.clientKey = clientKey
      storage.set('clientKey', clientKey)
    },
    setAppType({ state }, appType) {
      state.appType = appType
      storage.set('appType', appType)
    },
    setAppid({ state }, appid) {
      state.appid = appid
      storage.set('appid', appid)
    }
  }
}
